import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAnexoDocRenovado, getAnexoUser, getConsentimientoNuevo, getConsentimientoUsuarioNuevo, getDDJJNuevo, getDDJJUser, getDDJJUserNuevo } from '../../actions/index'
import 'reactjs-popup/dist/index.css';
import { PDFViewer } from '@react-pdf/renderer';
import AnexoPDF from '../ReactPDF/AnexoPDF'

const AdminANEXO = () => {

  const token = localStorage.getItem('token')


  const consentimiento = useSelector(state => state.consentimientoNuevo)
  
  const dispatch = useDispatch()
  
  useEffect(()=>{ 
    
    dispatch(getConsentimientoNuevo(token))
  }, [dispatch])
  

  
  return (
    <div>
      { consentimiento.length>1?
        <PDFViewer style={{ width: '100%', height: '100vh'}}>
        <AnexoPDF props={consentimiento} ddjj={consentimiento[2]} />
      </PDFViewer>:<div>Loading...</div>}
    </div>
  )
}

export default AdminANEXO